/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleCrossFill = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path d="M8,0 C12.416128,0.00518629776 15.9948137,3.58387202 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M5.16738197,5.16738996 C4.94420601,5.39172111 4.94420601,5.75339787 5.16738197,5.97658448 L7.19084406,8.00014307 L5.16738197,10.0237017 C4.94420601,10.2468883 4.94420601,10.608565 5.16738197,10.8328962 C5.2795422,10.9439172 5.4260372,11 5.57253219,11 C5.71902718,11 5.86552217,10.9439172 5.97653791,10.8328962 L8,8.80933759 L10.0234621,10.8328962 C10.1344778,10.9439172 10.2809728,11 10.4274678,11 C10.5739628,11 10.7204578,10.9439172 10.832618,10.8328962 C11.055794,10.608565 11.055794,10.2468883 10.832618,10.0237017 L8.80915594,8.00014307 L10.832618,5.97658448 C11.055794,5.75339787 11.055794,5.39172111 10.832618,5.16738996 C10.6082976,4.94420335 10.2466381,4.94420335 10.0234621,5.16738996 L8,7.19094854 L5.97653791,5.16738996 C5.75336195,4.94420335 5.39170243,4.94420335 5.16738197,5.16738996 Z" />
    </BaseSvgIcon>
  )
}

export default CircleCrossFill
